/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { Battlefield } from "../Battlefield";

export class Battlefield__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    floraArmyAddr: string,
    faunaArmyAddr: string,
    overrides?: Overrides
  ): Promise<Battlefield> {
    return super.deploy(
      floraArmyAddr,
      faunaArmyAddr,
      overrides || {}
    ) as Promise<Battlefield>;
  }
  getDeployTransaction(
    floraArmyAddr: string,
    faunaArmyAddr: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      floraArmyAddr,
      faunaArmyAddr,
      overrides || {}
    );
  }
  attach(address: string): Battlefield {
    return super.attach(address) as Battlefield;
  }
  connect(signer: Signer): Battlefield__factory {
    return super.connect(signer) as Battlefield__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Battlefield {
    return new Contract(address, _abi, signerOrProvider) as Battlefield;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "floraArmyAddr",
        type: "address",
      },
      {
        internalType: "address",
        name: "faunaArmyAddr",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "fieldID",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "conqueror",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bool",
        name: "isGreen",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "defender",
        type: "uint256[]",
      },
    ],
    name: "FieldState",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "proposer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalID",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "prefixURI",
        type: "string",
      },
    ],
    name: "Propose",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "totalArea",
        type: "uint256",
      },
    ],
    name: "TotalArea",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "fieldID",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "voter",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "proposalID",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "voteCount",
        type: "uint256",
      },
    ],
    name: "Vote",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "generation",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "winner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "tokenURI",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalCount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "voteCount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalArea",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "floraWin",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "faunaWin",
        type: "bool",
      },
    ],
    name: "Winner",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "propInterval_",
        type: "uint256",
      },
    ],
    name: "changePropInterval",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "seriesName_",
        type: "string",
      },
    ],
    name: "changeSeriesName",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "slottingFee_",
        type: "uint256",
      },
    ],
    name: "changeSlottingFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "voteInterval_",
        type: "uint256",
      },
    ],
    name: "changeVoteInterval",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "receiver",
        type: "address",
      },
    ],
    name: "claimFunds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "endVote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "increaseSize",
        type: "uint256",
      },
    ],
    name: "expand",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "faunaArmy",
    outputs: [
      {
        internalType: "contract ARMY",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "fieldID",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "attackerID",
        type: "uint256",
      },
    ],
    name: "faunaConquer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "faunaFieldCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "faunaOnField",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "fieldDefender",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "fieldGeneration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "fieldLocked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "floraArmy",
    outputs: [
      {
        internalType: "contract ARMY",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "fieldID",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "attackerID",
        type: "uint256",
      },
    ],
    name: "floraConquer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "floraFieldCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "floraOnField",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "generation",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAllProposalInfo",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "proposer",
            type: "address",
          },
          {
            internalType: "string",
            name: "prefixURI",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "voteCount",
            type: "uint256",
          },
        ],
        internalType: "struct Battlefield.Proposal[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "fieldID",
        type: "uint256",
      },
    ],
    name: "getFieldDefender",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "fieldID",
        type: "uint256",
      },
    ],
    name: "getFieldInfo",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "leader",
            type: "address",
          },
          {
            internalType: "uint256[]",
            name: "defender",
            type: "uint256[]",
          },
          {
            internalType: "bool",
            name: "isFlora",
            type: "bool",
          },
        ],
        internalType: "struct BattleBase.FieldInfo",
        name: "fieldInfo",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "fieldID",
        type: "uint256",
      },
    ],
    name: "getFieldLeader",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getProposalCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "startId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "area",
        type: "uint256",
      },
    ],
    name: "getRangeInfo",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "leader",
            type: "address",
          },
          {
            internalType: "uint256[]",
            name: "defender",
            type: "uint256[]",
          },
          {
            internalType: "bool",
            name: "isFlora",
            type: "bool",
          },
        ],
        internalType: "struct BattleBase.FieldInfo[]",
        name: "rangeInfo",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "isFloraField",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "propInterval",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "proposals",
    outputs: [
      {
        internalType: "address",
        name: "proposer",
        type: "address",
      },
      {
        internalType: "string",
        name: "prefixURI",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "voteCount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "prefixURI",
        type: "string",
      },
    ],
    name: "propose",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "fieldID",
        type: "uint256",
      },
    ],
    name: "retreat",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "seriesName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "slottingFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "startVote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalArea",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "fieldID",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "proposalID",
        type: "uint256",
      },
    ],
    name: "vote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "voteInterval",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x60806040523480156200001157600080fd5b5060405162004acd38038062004acd8339810160408190526200003491620002da565b6040518060400160405280601781526020017f466c6f7261264661756e6120426174746c656669656c640000000000000000008152506040518060400160405280600781526020016623132316a12a2360c91b8152508383620000a6620000a0620001c360201b60201c565b620001c7565b6000805460ff60a01b19168155601460018190556103e8600a55600680546001600160a01b038087166001600160a01b031992831617909255600780549286169290911691909117905560088290556009919091556040517f21e5668ec8085df78c0955e48cdf5939d94bd27059bd915d1258f6ec278c922d916200012e9190815260200190565b60405180910390a1505081516200014d90600b90602085019062000217565b5080516200016390600c90602084019062000217565b505060016017555062278d006015556206978060165560408051808201909152600b8082526a39b2b934b2b9973539b7b760a91b6020909201918252620001ad9160189162000217565b505064e8d4a5100060195550426014556200034e565b3390565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b828054620002259062000311565b90600052602060002090601f01602090048101928262000249576000855562000294565b82601f106200026457805160ff191683800117855562000294565b8280016001018555821562000294579182015b828111156200029457825182559160200191906001019062000277565b50620002a2929150620002a6565b5090565b5b80821115620002a25760008155600101620002a7565b80516001600160a01b0381168114620002d557600080fd5b919050565b60008060408385031215620002ed578182fd5b620002f883620002bd565b91506200030860208401620002bd565b90509250929050565b600181811c908216806200032657607f821691505b602082108114156200034857634e487b7160e01b600052602260045260246000fd5b50919050565b61476f806200035e6000396000f3fe60806040526004361061028a5760003560e01c806376ad68731161015b578063b41a6113116100c7578063b41a6113146107b7578063b6806492146107cc578063b88d4fde146107ec578063b92239461461080c578063c08cc02d14610821578063c60043ab14610836578063c72eafa91461084c578063c87b56dd1461087c578063da9f2f681461089c578063dc555090146108bc578063e985e9c5146108d2578063ea88a3b8146108f2578063ec4155a414610908578063f2fde38b1461091e57600080fd5b806376ad68731461060e5780638da5cb5b1461063b57806392e8bbdc1461065057806395d89b411461067d5780639daedb15146106925780639f6e1b72146106b2578063a22cb465146106c8578063a4a3578a146106e8578063a4cf84d114610708578063aa451ce81461072a578063aa98df3914610757578063b04329291461076a578063b384abef1461079757600080fd5b8063331cd2cc116101fa578063331cd2cc1461047d57806336baa7f7146104ad57806338e1359a146104ce578063390d6855146104ee57806342842e0e1461050e5780634c0a6af01461052e57806353fb45121461054357806355ba23741461056357806361b5b7fc146105835780636352211e14610599578063682904a5146105b957806370a08231146105d9578063715018a6146105f957600080fd5b8063013cf08b1461028f57806301b7fc1d146102c757806301ffc9a71461030757806306fdde0314610327578063081812fc14610349578063095ea7b3146103815780630c830e18146103a357806317219522146103c3578063233cf472146103e757806323b872dd146104075780632a46ceb7146104275780632c708d141461043d57806330df04471461045d575b600080fd5b34801561029b57600080fd5b506102af6102aa366004613f35565b61093e565b6040516102be93929190614168565b60405180910390f35b3480156102d357600080fd5b506102f76102e2366004613f35565b60046020526000908152604090205460ff1681565b60405190151581526020016102be565b34801561031357600080fd5b506102f7610322366004613e91565b610a06565b34801561033357600080fd5b5061033c610a58565b6040516102be91906142e2565b34801561035557600080fd5b50610369610364366004613f35565b610aea565b6040516001600160a01b0390911681526020016102be565b34801561038d57600080fd5b506103a161039c366004613e4a565b610b77565b005b3480156103af57600080fd5b506103a16103be366004613ec9565b610c88565b3480156103cf57600080fd5b506103d960175481565b6040519081526020016102be565b3480156103f357600080fd5b50600654610369906001600160a01b031681565b34801561041357600080fd5b506103a1610422366004613cbe565b610cc3565b34801561043357600080fd5b506103d960165481565b34801561044957600080fd5b506103d9610458366004613f89565b610cf4565b34801561046957600080fd5b506103a1610478366004613f35565b610d25565b34801561048957600080fd5b506102f7610498366004613f35565b60036020526000908152604090205460ff1681565b3480156104b957600080fd5b506000546102f790600160a01b900460ff1681565b3480156104da57600080fd5b506103a16104e9366004613f35565b610d59565b3480156104fa57600080fd5b506103a1610509366004613f65565b61103a565b34801561051a57600080fd5b506103a1610529366004613cbe565b61109f565b34801561053a57600080fd5b506103a16110ba565b34801561054f57600080fd5b5061036961055e366004613f35565b6111c3565b34801561056f57600080fd5b506103a161057e366004613f89565b6114a1565b34801561058f57600080fd5b506103d960095481565b3480156105a557600080fd5b506103696105b4366004613f35565b611874565b3480156105c557600080fd5b506103a16105d4366004613f35565b6118eb565b3480156105e557600080fd5b506103d96105f4366004613c4e565b611ad7565b34801561060557600080fd5b506103a1611b5e565b34801561061a57600080fd5b5061062e610629366004613f35565b611b99565b6040516102be919061456b565b34801561064757600080fd5b50610369611bf4565b34801561065c57600080fd5b506103d961066b366004613f35565b60136020526000908152604090205481565b34801561068957600080fd5b5061033c611c03565b34801561069e57600080fd5b50600754610369906001600160a01b031681565b3480156106be57600080fd5b506103d960085481565b3480156106d457600080fd5b506103a16106e3366004613dd6565b611c12565b3480156106f457600080fd5b506103a1610703366004613f35565b611cd3565b34801561071457600080fd5b5061071d611d07565b6040516102be91906141fd565b34801561073657600080fd5b5061074a610745366004613f89565b611e18565b6040516102be919061419c565b6103a1610765366004613ec9565b611ed9565b34801561077657600080fd5b5061078a610785366004613f35565b61206c565b6040516102be9190614288565b3480156107a357600080fd5b506103a16107b2366004613f89565b6120ce565b3480156107c357600080fd5b5061033c6124d8565b3480156107d857600080fd5b506103a16107e7366004613f35565b612566565b3480156107f857600080fd5b506103a1610807366004613cfe565b61259a565b34801561081857600080fd5b506103a16125d2565b34801561082d57600080fd5b506012546103d9565b34801561084257600080fd5b506103d960015481565b34801561085857600080fd5b506102f7610867366004613f35565b60056020526000908152604090205460ff1681565b34801561088857600080fd5b5061033c610897366004613f35565b6129ac565b3480156108a857600080fd5b506103a16108b7366004613f89565b612b23565b3480156108c857600080fd5b506103d960145481565b3480156108de57600080fd5b506102f76108ed366004613c86565b612ee1565b3480156108fe57600080fd5b506103d960195481565b34801561091457600080fd5b506103d960155481565b34801561092a57600080fd5b506103a1610939366004613c4e565b612f0f565b6012818154811061094e57600080fd5b6000918252602090912060039091020180546001820180546001600160a01b0390921693509061097d9061463a565b80601f01602080910402602001604051908101604052809291908181526020018280546109a99061463a565b80156109f65780601f106109cb576101008083540402835291602001916109f6565b820191906000526020600020905b8154815290600101906020018083116109d957829003601f168201915b5050505050908060020154905083565b60006001600160e01b031982166380ac58cd60e01b1480610a3757506001600160e01b03198216635b5e139f60e01b145b80610a5257506301ffc9a760e01b6001600160e01b03198316145b92915050565b6060600b8054610a679061463a565b80601f0160208091040260200160405190810160405280929190818152602001828054610a939061463a565b8015610ae05780601f10610ab557610100808354040283529160200191610ae0565b820191906000526020600020905b815481529060010190602001808311610ac357829003601f168201915b5050505050905090565b6000610af582612faf565b610b5b5760405162461bcd60e51b815260206004820152602c60248201527f4552433732313a20617070726f76656420717565727920666f72206e6f6e657860448201526b34b9ba32b73a103a37b5b2b760a11b60648201526084015b60405180910390fd5b506000908152600f60205260409020546001600160a01b031690565b6000610b8282611874565b9050806001600160a01b0316836001600160a01b03161415610bf05760405162461bcd60e51b815260206004820152602160248201527f4552433732313a20617070726f76616c20746f2063757272656e74206f776e656044820152603960f91b6064820152608401610b52565b336001600160a01b0382161480610c0c5750610c0c8133612ee1565b610c795760405162461bcd60e51b815260206004820152603860248201527f4552433732313a20617070726f76652063616c6c6572206973206e6f74206f776044820152771b995c881b9bdc88185c1c1c9bdd995908199bdc88185b1b60421b6064820152608401610b52565b610c838383612fcc565b505050565b33610c91611bf4565b6001600160a01b031614610cb75760405162461bcd60e51b8152600401610b5290614468565b610c8360188383613a67565b610ccd338261303a565b610ce95760405162461bcd60e51b8152600401610b529061451a565b610c838383836130fc565b60026020528160005260406000208181548110610d1057600080fd5b90600052602060002001600091509150505481565b33610d2e611bf4565b6001600160a01b031614610d545760405162461bcd60e51b8152600401610b5290614468565b601655565b600081815260026020908152604080832080548251818502810185019093528083529192909190830182828015610daf57602002820191906000526020600020905b815481526020019060010190808311610d9b575b505050505090506000815111610e155760405162461bcd60e51b815260206004820152602560248201527f426174746c656669656c643a20726574726561742066726f6d20656d70747920604482015264199a595b1960da1b6064820152608401610b52565b600081600081518110610e3857634e487b7160e01b600052603260045260246000fd5b6020908102919091018101516000858152600390925260409091205490915060ff1615610f1c576006546040516331a9108f60e11b81526004810183905233916001600160a01b031690636352211e9060240160206040518083038186803b158015610ea357600080fd5b505afa158015610eb7573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610edb9190613c6a565b6001600160a01b031614610f015760405162461bcd60e51b8152600401610b5290614400565b6000818152600460205260409020805460ff19169055610fd5565b6007546040516331a9108f60e11b81526004810183905233916001600160a01b031690636352211e9060240160206040518083038186803b158015610f6057600080fd5b505afa158015610f74573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f989190613c6a565b6001600160a01b031614610fbe5760405162461bcd60e51b8152600401610b5290614400565b6000818152600560205260409020805460ff191690555b6000838152600260205260408120610fec91613aeb565b6000838152600360209081526040808320546002909252808320905160ff90921615159291869160008051602061471a8339815191529161102d919061429b565b60405180910390a4505050565b33611043611bf4565b6001600160a01b0316146110695760405162461bcd60e51b8152600401610b5290614468565b6040516001600160a01b0382169083156108fc029084906000818181858888f19350505050158015610c83573d6000803e3d6000fd5b610c838383836040518060200160405280600081525061259a565b600054600160a01b900460ff16156110e45760405162461bcd60e51b8152600401610b5290614431565b6012546001106111405760405162461bcd60e51b815260206004820152602160248201527f426174746c656669656c643a206e6f7420656e6f7567682070726f706f73616c6044820152607360f81b6064820152608401610b52565b6015546014544291611151916145b4565b8110156111ab5760405162461bcd60e51b815260206004820152602260248201527f426174746c656669656c643a206e6f742079657420746f20737461727420766f604482015261746560f01b6064820152608401610b52565b6014556000805460ff60a01b1916600160a01b179055565b60008181526002602090815260408083208054825181850281018501909352808352849383018282801561121657602002820191906000526020600020905b815481526020019060010190808311611202575b505050505090508051600014156112305750600092915050565b60008381526003602052604090205460ff16156113b45760065481516001600160a01b039091169063d024851690839060009061127d57634e487b7160e01b600052603260045260246000fd5b60200260200101516040518263ffffffff1660e01b81526004016112a391815260200190565b60206040518083038186803b1580156112bb57600080fd5b505afa1580156112cf573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906112f39190613e75565b156113ab5760065481516001600160a01b0390911690636352211e90839060009061132e57634e487b7160e01b600052603260045260246000fd5b60200260200101516040518263ffffffff1660e01b815260040161135491815260200190565b60206040518083038186803b15801561136c57600080fd5b505afa158015611380573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906113a49190613c6a565b9392505050565b50600092915050565b60075481516001600160a01b039091169063d02485169083906000906113ea57634e487b7160e01b600052603260045260246000fd5b60200260200101516040518263ffffffff1660e01b815260040161141091815260200190565b60206040518083038186803b15801561142857600080fd5b505afa15801561143c573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906114609190613e75565b156113ab5760075481516001600160a01b0390911690636352211e90839060009061132e57634e487b7160e01b600052603260045260246000fd5b50919050565b6000548290600160a01b900460ff16156114cd5760405162461bcd60e51b8152600401610b529061449d565b60015481106114ee5760405162461bcd60e51b8152600401610b52906143c9565b60008281526004602052604090205460ff16156115645760405162461bcd60e51b815260206004820152602e60248201527f426174746c656669656c643a2074686520666c6f7261206d696e696f6e20616c60448201526d1c9958591e481bdb88199a595b1960921b6064820152608401610b52565b6006546040516331a9108f60e11b81526004810184905233916001600160a01b031690636352211e9060240160206040518083038186803b1580156115a857600080fd5b505afa1580156115bc573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906115e09190613c6a565b6001600160a01b0316146116515760405162461bcd60e51b815260206004820152603260248201527f426174746c656669656c643a206e6f742074686520636f6d6d616e646572206f60448201527133103a343290333637b9309036b4b734b7b760711b6064820152608401610b52565b6000838152600260209081526040808320805482518185028101850190935280835291929091908301828280156116a757602002820191906000526020600020905b815481526020019060010190808311611693575b505050505090506000815111156117d2576000816000815181106116db57634e487b7160e01b600052603260045260246000fd5b6020908102919091018101516000878152600390925260409091205490915060ff16156117355760065461171a906001600160a01b031685818461329c565b6000818152600460205260409020805460ff19169055611793565b600654600754611754916001600160a01b03908116918791168461329c565b6000818152600560205260408120805460ff19169055600980549161177883614623565b90915550506008805490600061178d8361466f565b91905055505b600085815260026020526040812080548692906117c057634e487b7160e01b600052603260045260246000fd5b60009182526020909120015550611808565b6000848152600260209081526040822080546001810182559083529082200184905560088054916118028361466f565b91905055505b60008381526004602090815260408083208054600160ff19918216811790925588855260038452828520805490911682179055600290925291829020915190913391879160008051602061471a83398151915291611866919061429b565b60405180910390a450505050565b6000818152600d60205260408120546001600160a01b031680610a525760405162461bcd60e51b815260206004820152602960248201527f4552433732313a206f776e657220717565727920666f72206e6f6e657869737460448201526832b73a103a37b5b2b760b91b6064820152608401610b52565b336118f4611bf4565b6001600160a01b03161461191a5760405162461bcd60e51b8152600401610b5290614468565b806001600082825461192c91906145b4565b9091555050600754604080516318160ddd60e01b815290516001600160a01b03909216916318160ddd91600480820192602092909190829003018186803b15801561197657600080fd5b505afa15801561198a573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906119ae9190613f4d565b600660009054906101000a90046001600160a01b03166001600160a01b03166318160ddd6040518163ffffffff1660e01b815260040160206040518083038186803b1580156119fc57600080fd5b505afa158015611a10573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611a349190613f4d565b611a3e91906145b4565b60015410611a995760405162461bcd60e51b815260206004820152602260248201527f426174746c656669656c643a206e6f206e65656420666f7220657870616e736960448201526137b760f11b6064820152608401610b52565b7f21e5668ec8085df78c0955e48cdf5939d94bd27059bd915d1258f6ec278c922d600154604051611acc91815260200190565b60405180910390a150565b60006001600160a01b038216611b425760405162461bcd60e51b815260206004820152602a60248201527f4552433732313a2062616c616e636520717565727920666f7220746865207a65604482015269726f206164647265737360b01b6064820152608401610b52565b506001600160a01b03166000908152600e602052604090205490565b33611b67611bf4565b6001600160a01b031614611b8d5760405162461bcd60e51b8152600401610b5290614468565b611b9760006134d8565b565b611ba1613b09565b611baa826111c3565b6001600160a01b031680825215611bec57611bc48261206c565b602080830191909152600083815260039091526040908190205460ff16151590820152919050565b610a52613b09565b6000546001600160a01b031690565b6060600c8054610a679061463a565b6001600160a01b038216331415611c675760405162461bcd60e51b815260206004820152601960248201527822a9219b99189d1030b8383937bb32903a379031b0b63632b960391b6044820152606401610b52565b3360008181526010602090815260408083206001600160a01b03871680855290835292819020805460ff191686151590811790915590519081529192917f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31910160405180910390a35050565b33611cdc611bf4565b6001600160a01b031614611d025760405162461bcd60e51b8152600401610b5290614468565b601955565b60606012805480602002602001604051908101604052809291908181526020016000905b82821015611e0f57600084815260209081902060408051606081019091526003850290910180546001600160a01b031682526001810180549293919291840191611d749061463a565b80601f0160208091040260200160405190810160405280929190818152602001828054611da09061463a565b8015611ded5780601f10611dc257610100808354040283529160200191611ded565b820191906000526020600020905b815481529060010190602001808311611dd057829003601f168201915b5050505050815260200160028201548152505081526020019060010190611d2b565b50505050905090565b6060816001600160401b03811115611e4057634e487b7160e01b600052604160045260246000fd5b604051908082528060200260200182016040528015611e7957816020015b611e66613b09565b815260200190600190039081611e5e5790505b50905060005b82811015611ed257611e9461062982866145b4565b828281518110611eb457634e487b7160e01b600052603260045260246000fd5b60200260200101819052508080611eca9061466f565b915050611e7f565b5092915050565b600054600160a01b900460ff1615611f035760405162461bcd60e51b8152600401610b5290614431565b601954341015611f615760405162461bcd60e51b8152602060048201526024808201527f426174746c656669656c643a206e6f7420656e6f75676820736c6f7474696e676044820152632066656560e01b6064820152608401610b52565b60126040518060600160405280336001600160a01b0316815260200184848080601f0160208091040260200160405190810160405280939291908181526020018383808284376000920182905250938552505050602091820181905283546001808201865594825290829020835160039092020180546001600160a01b0319166001600160a01b039092169190911781558282015180519394919361200e93928501929190910190613b35565b506040919091015160029091015560125433907f75656bcb503b4e9a5d049db76f375436e37366365e3c547fd8003802dd9804fb9061204f906001906145e0565b84846040516120609392919061457e565b60405180910390a25050565b6000818152600260209081526040918290208054835181840281018401909452808452606093928301828280156120c257602002820191906000526020600020905b8154815260200190600101908083116120ae575b50505050509050919050565b600054600160a01b900460ff166120f75760405162461bcd60e51b8152600401610b5290614335565b6017546000838152601360205260409020541061216e5760405162461bcd60e51b815260206004820152602f60248201527f426174746c656669656c643a206669656c642068617320766f74656420696e2060448201526e3a3434b99033b2b732b930ba34b7b760891b6064820152608401610b52565b6000828152600260209081526040808320805482518185028101850190935280835291929091908301828280156121c457602002820191906000526020600020905b8154815260200190600101908083116121b0575b5050505050905060008151116122285760405162461bcd60e51b815260206004820152602360248201527f426174746c656669656c643a20656d707479206669656c642063616e277420766044820152626f746560e81b6064820152608401610b52565b60008381526003602052604090205460ff161561233a57600654815133916001600160a01b031690636352211e90849060009061227557634e487b7160e01b600052603260045260246000fd5b60200260200101516040518263ffffffff1660e01b815260040161229b91815260200190565b60206040518083038186803b1580156122b357600080fd5b505afa1580156122c7573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906122eb9190613c6a565b6001600160a01b0316146123115760405162461bcd60e51b8152600401610b5290614400565b60095460085410156123355760405162461bcd60e51b8152600401610b52906144e3565b612430565b600754815133916001600160a01b031690636352211e90849060009061237057634e487b7160e01b600052603260045260246000fd5b60200260200101516040518263ffffffff1660e01b815260040161239691815260200190565b60206040518083038186803b1580156123ae57600080fd5b505afa1580156123c2573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906123e69190613c6a565b6001600160a01b03161461240c5760405162461bcd60e51b8152600401610b5290614400565b60085460095410156124305760405162461bcd60e51b8152600401610b52906144e3565b60006012838154811061245357634e487b7160e01b600052603260045260246000fd5b906000526020600020906003020190508060020160008154809291906124789061466f565b9190505550601754601360008681526020019081526020016000208190555082336001600160a01b0316857f691caaa3fac07e755c9e46e4877cbd04f37fd1b9be1bfc9851f6a520aad29c13846002015460405161186691815260200190565b601880546124e59061463a565b80601f01602080910402602001604051908101604052809291908181526020018280546125119061463a565b801561255e5780601f106125335761010080835404028352916020019161255e565b820191906000526020600020905b81548152906001019060200180831161254157829003601f168201915b505050505081565b3361256f611bf4565b6001600160a01b0316146125955760405162461bcd60e51b8152600401610b5290614468565b601555565b6125a4338361303a565b6125c05760405162461bcd60e51b8152600401610b529061451a565b6125cc84848484613528565b50505050565b600054600160a01b900460ff166125fb5760405162461bcd60e51b8152600401610b5290614335565b601654601454429161260c916145b4565b81101561265b5760405162461bcd60e51b815260206004820181905260248201527f426174746c656669656c643a206e6f742079657420746f20656e6420766f74656044820152606401610b52565b6014819055600080805b6012548110156126f457826012828154811061269157634e487b7160e01b600052603260045260246000fd5b90600052602060002090600302016002015411156126e257601281815481106126ca57634e487b7160e01b600052603260045260246000fd5b90600052602060002090600302016002015492508091505b806126ec8161466f565b915050612665565b5060006012828154811061271857634e487b7160e01b600052603260045260246000fd5b6000918252602091829020604080516060810190915260039092020180546001600160a01b0316825260018101805492939192918401916127589061463a565b80601f01602080910402602001604051908101604052809291908181526020018280546127849061463a565b80156127d15780601f106127a6576101008083540402835291602001916127d1565b820191906000526020600020905b8154815290600101906020018083116127b457829003601f168201915b5050505050815260200160028201548152505090506000806009546008541061285e57600654602084015160405163931688cb60e01b81526001600160a01b039092169163931688cb91612827916004016142e2565b600060405180830381600087803b15801561284157600080fd5b505af1158015612855573d6000803e3d6000fd5b50505050600191505b600854600954106128d357600754602084015160405163931688cb60e01b81526001600160a01b039092169163931688cb9161289c916004016142e2565b600060405180830381600087803b1580156128b657600080fd5b505af11580156128ca573d6000803e3d6000fd5b50505050600190505b6128e3836000015160175461355b565b6129156017548460200151601860405160200161290192919061407c565b604051602081830303815290604052613579565b61292160126000613ba9565b6000805460ff60a01b1916905582516017546001600160a01b03909116907fbcce7ae1b0eda5f386742164a672abb073651089d04d044faa6352139ceb565c612969826129ac565b6012546040808901516001549151612987949392908a908a906142f5565b60405180910390a36017805490600061299f8361466f565b9190505550505050505050565b60606129b782612faf565b612a1d5760405162461bcd60e51b815260206004820152603160248201527f45524337323155524953746f726167653a2055524920717565727920666f72206044820152703737b732bc34b9ba32b73a103a37b5b2b760791b6064820152608401610b52565b60008281526011602052604081208054612a369061463a565b80601f0160208091040260200160405190810160405280929190818152602001828054612a629061463a565b8015612aaf5780601f10612a8457610100808354040283529160200191612aaf565b820191906000526020600020905b815481529060010190602001808311612a9257829003601f168201915b505050505090506000612acd60408051602081019091526000815290565b9050805160001415612ae0575092915050565b815115612b12578082604051602001612afa92919061404d565b60405160208183030381529060405292505050919050565b612b1b84613604565b949350505050565b6000548290600160a01b900460ff1615612b4f5760405162461bcd60e51b8152600401610b529061449d565b6001548110612b705760405162461bcd60e51b8152600401610b52906143c9565b60008281526005602052604090205460ff1615612be65760405162461bcd60e51b815260206004820152602e60248201527f426174746c656669656c643a20746865206661756e61206d696e696f6e20616c60448201526d1c9958591e481bdb88199a595b1960921b6064820152608401610b52565b6007546040516331a9108f60e11b81526004810184905233916001600160a01b031690636352211e9060240160206040518083038186803b158015612c2a57600080fd5b505afa158015612c3e573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612c629190613c6a565b6001600160a01b031614612cd35760405162461bcd60e51b815260206004820152603260248201527f426174746c656669656c643a206e6f742074686520636f6d6d616e646572206f60448201527133103a3432903330bab7309036b4b734b7b760711b6064820152608401610b52565b600083815260026020908152604080832080548251818502810185019093528083529192909190830182828015612d2957602002820191906000526020600020905b815481526020019060010190808311612d15575b50505050509050600081511115612e5457600081600081518110612d5d57634e487b7160e01b600052603260045260246000fd5b6020908102919091018101516000878152600390925260409091205490915060ff1615612de657600754600654612da3916001600160a01b03908116918791168461329c565b6000818152600460205260408120805460ff191690556008805491612dc783614623565b909155505060098054906000612ddc8361466f565b9190505550612e15565b600754612dfe906001600160a01b031685818461329c565b6000818152600560205260409020805460ff191690555b60008581526002602052604081208054869290612e4257634e487b7160e01b600052603260045260246000fd5b60009182526020909120015550612e8a565b600084815260026020908152604082208054600181018255908352908220018490556009805491612e848361466f565b91905055505b6000838152600560209081526040808320805460ff199081166001179091558784526003835281842080549091169055600290915280822090513391879160008051602061471a833981519152916118669161429b565b6001600160a01b03918216600090815260106020908152604080832093909416825291909152205460ff1690565b33612f18611bf4565b6001600160a01b031614612f3e5760405162461bcd60e51b8152600401610b5290614468565b6001600160a01b038116612fa35760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b6064820152608401610b52565b612fac816134d8565b50565b6000908152600d60205260409020546001600160a01b0316151590565b6000818152600f6020526040902080546001600160a01b0319166001600160a01b038416908117909155819061300182611874565b6001600160a01b03167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92560405160405180910390a45050565b600061304582612faf565b6130a65760405162461bcd60e51b815260206004820152602c60248201527f4552433732313a206f70657261746f7220717565727920666f72206e6f6e657860448201526b34b9ba32b73a103a37b5b2b760a11b6064820152608401610b52565b60006130b183611874565b9050806001600160a01b0316846001600160a01b031614806130ec5750836001600160a01b03166130e184610aea565b6001600160a01b0316145b80612b1b5750612b1b8185612ee1565b826001600160a01b031661310f82611874565b6001600160a01b0316146131775760405162461bcd60e51b815260206004820152602960248201527f4552433732313a207472616e73666572206f6620746f6b656e2074686174206960448201526839903737ba1037bbb760b91b6064820152608401610b52565b6001600160a01b0382166131d95760405162461bcd60e51b8152602060048201526024808201527f4552433732313a207472616e7366657220746f20746865207a65726f206164646044820152637265737360e01b6064820152608401610b52565b6131e4600082612fcc565b6001600160a01b0383166000908152600e6020526040812080546001929061320d9084906145e0565b90915550506001600160a01b0382166000908152600e6020526040812080546001929061323b9084906145b4565b90915550506000818152600d602052604080822080546001600160a01b0319166001600160a01b0386811691821790925591518493918716917fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef91a4505050565b604051636812428b60e11b8152600481018290526001600160a01b0383169063d02485169060240160206040518083038186803b1580156132dc57600080fd5b505afa1580156132f0573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906133149190613e75565b156125cc5760405163df069b1160e01b81526004810184905260009081906001600160a01b0387169063df069b119060240160806040518083038186803b15801561335e57600080fd5b505afa158015613372573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906133969190613e03565b935050925050600080856001600160a01b031663df069b11866040518263ffffffff1660e01b81526004016133cd91815260200190565b60806040518083038186803b1580156133e557600080fd5b505afa1580156133f9573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061341d9190613e03565b9350509250508361347e5760405162461bcd60e51b815260206004820152602560248201527f426174746c656669656c643a2061747461636b65722073686f756c6420626520604482015264185c9b595960da1b6064820152608401610b52565b81158061348a57508083135b6134ce5760405162461bcd60e51b815260206004820152601560248201527410985d1d1b19599a595b190e8819195999585d1959605a1b6044820152606401610b52565b5050505050505050565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b6135338484846130fc565b61353f848484846136db565b6125cc5760405162461bcd60e51b8152600401610b5290614377565b6135758282604051806020016040528060008152506137e8565b5050565b61358282612faf565b6135e55760405162461bcd60e51b815260206004820152602e60248201527f45524337323155524953746f726167653a2055524920736574206f66206e6f6e60448201526d32bc34b9ba32b73a103a37b5b2b760911b6064820152608401610b52565b60008281526011602090815260409091208251610c8392840190613b35565b606061360f82612faf565b6136735760405162461bcd60e51b815260206004820152602f60248201527f4552433732314d657461646174613a2055524920717565727920666f72206e6f60448201526e3732bc34b9ba32b73a103a37b5b2b760891b6064820152608401610b52565b600061368a60408051602081019091526000815290565b905060008151116136aa57604051806020016040528060008152506113a4565b806136b48461381b565b6040516020016136c592919061404d565b6040516020818303038152906040529392505050565b60006001600160a01b0384163b156137dd57604051630a85bd0160e11b81526001600160a01b0385169063150b7a029061371f90339089908890889060040161412b565b602060405180830381600087803b15801561373957600080fd5b505af1925050508015613769575060408051601f3d908101601f1916820190925261376691810190613ead565b60015b6137c3573d808015613797576040519150601f19603f3d011682016040523d82523d6000602084013e61379c565b606091505b5080516137bb5760405162461bcd60e51b8152600401610b5290614377565b805181602001fd5b6001600160e01b031916630a85bd0160e11b149050612b1b565b506001949350505050565b6137f28383613934565b6137ff60008484846136db565b610c835760405162461bcd60e51b8152600401610b5290614377565b60608161383f5750506040805180820190915260018152600360fc1b602082015290565b8160005b811561386957806138538161466f565b91506138629050600a836145cc565b9150613843565b6000816001600160401b0381111561389157634e487b7160e01b600052604160045260246000fd5b6040519080825280601f01601f1916602001820160405280156138bb576020820181803683370190505b5090505b8415612b1b576138d06001836145e0565b91506138dd600a8661468a565b6138e89060306145b4565b60f81b81838151811061390b57634e487b7160e01b600052603260045260246000fd5b60200101906001600160f81b031916908160001a90535061392d600a866145cc565b94506138bf565b6001600160a01b03821661398a5760405162461bcd60e51b815260206004820181905260248201527f4552433732313a206d696e7420746f20746865207a65726f20616464726573736044820152606401610b52565b61399381612faf565b156139e05760405162461bcd60e51b815260206004820152601c60248201527f4552433732313a20746f6b656e20616c7265616479206d696e746564000000006044820152606401610b52565b6001600160a01b0382166000908152600e60205260408120805460019290613a099084906145b4565b90915550506000818152600d602052604080822080546001600160a01b0319166001600160a01b03861690811790915590518392907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef908290a45050565b828054613a739061463a565b90600052602060002090601f016020900481019282613a955760008555613adb565b82601f10613aae5782800160ff19823516178555613adb565b82800160010185558215613adb579182015b82811115613adb578235825591602001919060010190613ac0565b50613ae7929150613bca565b5090565b5080546000825590600052602060002090810190612fac9190613bca565b604051806060016040528060006001600160a01b03168152602001606081526020016000151581525090565b828054613b419061463a565b90600052602060002090601f016020900481019282613b635760008555613adb565b82601f10613b7c57805160ff1916838001178555613adb565b82800160010185558215613adb579182015b82811115613adb578251825591602001919060010190613b8e565b5080546000825560030290600052602060002090810190612fac9190613bdf565b5b80821115613ae75760008155600101613bcb565b80821115613ae75780546001600160a01b03191681556000613c046001830182613c14565b5060006002820155600301613bdf565b508054613c209061463a565b6000825580601f10613c30575050565b601f016020900490600052602060002090810190612fac9190613bca565b600060208284031215613c5f578081fd5b81356113a4816146e0565b600060208284031215613c7b578081fd5b81516113a4816146e0565b60008060408385031215613c98578081fd5b8235613ca3816146e0565b91506020830135613cb3816146e0565b809150509250929050565b600080600060608486031215613cd2578081fd5b8335613cdd816146e0565b92506020840135613ced816146e0565b929592945050506040919091013590565b60008060008060808587031215613d13578081fd5b8435613d1e816146e0565b93506020850135613d2e816146e0565b92506040850135915060608501356001600160401b0380821115613d50578283fd5b818701915087601f830112613d63578283fd5b813581811115613d7557613d756146ca565b604051601f8201601f19908116603f01168101908382118183101715613d9d57613d9d6146ca565b816040528281528a6020848701011115613db5578586fd5b82602086016020830137918201602001949094529598949750929550505050565b60008060408385031215613de8578182fd5b8235613df3816146e0565b91506020830135613cb3816146f5565b60008060008060808587031215613e18578384fd5b8451613e23816146e0565b6020860151909450613e34816146f5565b6040860151606090960151949790965092505050565b60008060408385031215613e5c578182fd5b8235613e67816146e0565b946020939093013593505050565b600060208284031215613e86578081fd5b81516113a4816146f5565b600060208284031215613ea2578081fd5b81356113a481614703565b600060208284031215613ebe578081fd5b81516113a481614703565b60008060208385031215613edb578182fd5b82356001600160401b0380821115613ef1578384fd5b818501915085601f830112613f04578384fd5b813581811115613f12578485fd5b866020828501011115613f23578485fd5b60209290920196919550909350505050565b600060208284031215613f46578081fd5b5035919050565b600060208284031215613f5e578081fd5b5051919050565b60008060408385031215613f77578182fd5b823591506020830135613cb3816146e0565b60008060408385031215613f9b578182fd5b50508035926020909101359150565b6000815180845260208085019450808401835b83811015613fd957815187529582019590820190600101613fbd565b509495945050505050565b60008151808452613ffc8160208601602086016145f7565b601f01601f19169290920160200192915050565b60018060a01b03815116825260006020820151606060208501526140376060850182613faa565b6040938401511515949093019390935250919050565b6000835161405f8184602088016145f7565b8351908301906140738183602088016145f7565b01949350505050565b60008351602061408f82858389016145f7565b8454918401918390600181811c90808316806140ac57607f831692505b8583108114156140ca57634e487b7160e01b88526022600452602488fd5b8080156140de57600181146140ef5761411b565b60ff1985168852838801955061411b565b60008b815260209020895b858110156141135781548a8201529084019088016140fa565b505083880195505b50939a9950505050505050505050565b6001600160a01b038581168252841660208201526040810183905260806060820181905260009061415e90830184613fe4565b9695505050505050565b6001600160a01b038416815260606020820181905260009061418c90830185613fe4565b9050826040830152949350505050565b6000602080830181845280855180835260408601915060408160051b8701019250838701855b828110156141f057603f198886030184526141de858351614010565b945092850192908501906001016141c2565b5092979650505050505050565b60006020808301818452808551808352604092508286019150828160051b870101848801865b8381101561427a57888303603f19018552815180516001600160a01b031684528781015160608986018190529061425c82870182613fe4565b92890151958901959095525094870194925090860190600101614223565b509098975050505050505050565b6020815260006113a46020830184613faa565b6020808252825482820181905260008481528281209092916040850190845b818110156142d6578354835260019384019392850192016142ba565b50909695505050505050565b6020815260006113a46020830184613fe4565b60c08152600061430860c0830189613fe4565b6020830197909752506040810194909452606084019290925215156080830152151560a090910152919050565b60208082526022908201527f426174746c656669656c643a206e6f7420696e2070726f706f73616c20737461604082015261746560f01b606082015260800190565b60208082526032908201527f4552433732313a207472616e7366657220746f206e6f6e20455243373231526560408201527131b2b4bb32b91034b6b83632b6b2b73a32b960711b606082015260800190565b6020808252601f908201527f426174746c656669656c643a206669656c64206f7574206f662072616e676500604082015260600190565b6020808252601790820152762130ba3a3632b334b2b6321d103737ba103632b0b232b960491b604082015260600190565b6020808252601e908201527f426174746c656669656c643a206e6f7420696e20766f74652073746174650000604082015260600190565b6020808252818101527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604082015260600190565b60208082526026908201527f426174746c656669656c643a20626174746c656669656c64206973206c6f636b6040820152656564206e6f7760d01b606082015260800190565b6020808252601e908201527f426174746c656669656c643a20796f75277265206c6f73657220736964650000604082015260600190565b60208082526031908201527f4552433732313a207472616e736665722063616c6c6572206973206e6f74206f6040820152701ddb995c881b9bdc88185c1c1c9bdd9959607a1b606082015260800190565b6020815260006113a46020830184614010565b83815260406020820152816040820152818360608301376000818301606090810191909152601f909201601f1916010192915050565b600082198211156145c7576145c761469e565b500190565b6000826145db576145db6146b4565b500490565b6000828210156145f2576145f261469e565b500390565b60005b838110156146125781810151838201526020016145fa565b838111156125cc5750506000910152565b6000816146325761463261469e565b506000190190565b600181811c9082168061464e57607f821691505b6020821081141561149b57634e487b7160e01b600052602260045260246000fd5b60006000198214156146835761468361469e565b5060010190565b600082614699576146996146b4565b500690565b634e487b7160e01b600052601160045260246000fd5b634e487b7160e01b600052601260045260246000fd5b634e487b7160e01b600052604160045260246000fd5b6001600160a01b0381168114612fac57600080fd5b8015158114612fac57600080fd5b6001600160e01b031981168114612fac57600080fdfe9a3c276128da5bf5f6a0c9b8df4df4c267f0ca732b1708cb8425bf3c308fef19a2646970667358221220318499594a41488fd196b9f96df80acfc7a92046fb88f6ac61809fe69483056764736f6c63430008040033";
